import { Component, ViewChild } from '@angular/core';
import { ToastrService, ToastContainerDirective } from 'ngx-toastr';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;

  constructor(
    private toastr: ToastrService) { }

  ngOnInit() {
    this.toastr.overlayContainer = this.toastContainer;
  }
  title = 'app';
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/app.component.ts